// eslint-disable-next-line @typescript-eslint/no-explicit-any
function preventDefault(cb) {
    return function(e) {
        if (e != null) {
            e.preventDefault();
        }
        cb === null || cb === void 0 ? void 0 : cb(e);
    };
}
var MIN_WORDS_FOR_NON_BREAKING_SPACE = 4;
/**
 * Will make sure last 2 words are joined with non-breaking space, unless the text is 3 or less words
 * @param text :string - text we want to prevent its last word to be in newline
 * @param force :boolean - indicates if the last two words should always have non-breaking space even if the text is under 3 words
 * @returns text with two last words connected with non-breaking space
 */ function preventOneWordInLastLine(text) {
    var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return text.split(" ").length >= MIN_WORDS_FOR_NON_BREAKING_SPACE || force ? text.trim().replace(/ (?=[^ ]*$)/i, "\xa0") : text;
}

export { preventDefault, preventOneWordInLastLine };
